import { axios } from '@/util/axios.js';
const baseUrl = '/api'

/* 获取测点模拟数据配置 */
export function getPointSimulate(params = {}, callback) {
    return axios.request({
        url: baseUrl + '/point_simulate/' + params.point_id + '/',
        method: 'get'
    }, callback)
}

/* 配置测点模拟数据 */
export function updatePointSimulate(params = {}, callback) {
    return axios.request({
        url: baseUrl + '/point_simulate/' + params.point_id + '/',
        method: 'put',
        data: params.data
    }, callback)
}



// WEBPACK FOOTER //
// ./src/data/pointSimulate.js